import { useEffect, useState } from 'react'
import { useBoolean } from 'usehooks-ts'
import { FindArtResultArtwork } from '../types'

const useFindArtSteps = () => {
  const [stepIndex, setStepIndex] = useState(0)
  const [iter, setIter] = useState(0)
  const [isReachingEnd, setIsReachingEnd] = useState(false)
  const [uniqueId, setUniqueId] = useState<string | null>(null)
  const [artworks, setArtworks] = useState<Array<FindArtResultArtwork>>([])
  const { value: isFinalSreenVisible, setTrue: showFinalScreen, setFalse: hideFinalScreen } = useBoolean(false)
  const { value: isResultScreenVisible, setTrue: showResultScreen } = useBoolean(false)
  const shouldShowSteps = !isFinalSreenVisible && !isResultScreenVisible
  const onShowResults = () => {
    hideFinalScreen()
    showResultScreen()
  }

  useEffect(() => {
    return () => {
      setUniqueId(null)
      setIter(0)
      setArtworks([])
      setIsReachingEnd(false)
    }
  }, [])

  return {
    isReachingEnd,
    setIsReachingEnd,
    iter,
    setIter,
    uniqueId,
    setUniqueId,
    artworks,
    setArtworks,
    stepIndex,
    setStepIndex,
    isFinalSreenVisible,
    isResultScreenVisible,
    shouldShowSteps,
    onShowResults,
    showFinalScreen,
  }
}

export default useFindArtSteps
